/* @flow */
import React from 'react';

import BoxTitle from 'components/BoxTitle.jsx';
import Button from 'components/Button.jsx';
import DeviceActions from 'actions/DeviceActions';

import 'styles/utilities.scss';

const ConfirmEmail = React.createClass({
  propTypes: {
    uid: React.PropTypes.string.isRequired,
    onGoBack: React.PropTypes.func,
  },

  componentDidMount() {
    DeviceActions.resendConfirmationEmail(this.props.uid);
  },

  render() {
    return (
      <div className="ConfirmEmail">
        <BoxTitle>Check your email to continue</BoxTitle>
        <p className="block">
          It looks like you’ve already used Remind, so we sent you a confirmation email. Click on
          the link in the email to finish signing up for Remind!
        </p>
        <Button
          level="text"
          onClick={this.props.onGoBack}>
          Go back
        </Button>
      </div>
    );
  },
});

export default ConfirmEmail;



// WEBPACK FOOTER //
// ./src/auth/components/ConfirmEmail.jsx